var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_9697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00961 21.486L0 0.0401001L24 0.0831967L21.875 21.486L12.0906 23.9599L2.00961 21.486Z",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0908 21.8887V2.08252L21.9742 2.11125L20.2117 19.8317L12.0908 21.8887Z",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.256 7.03051L19.5358 4.4126H4.33203L5.17203 12.4387H15.6649L15.2534 15.8619L11.893 16.6529L8.48326 15.7899L8.3021 13.7475H5.28739L5.69926 17.9187L11.8928 19.429L18.1357 17.9187L18.9757 9.77771H7.95603L7.64306 7.03051H19.256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_9697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Icon1);
export default __webpack_public_path__ + "static/media/html5-icon (1).19fdc2881ea56be380f872be4474d3e3.svg";
export { ForwardRef as ReactComponent };